module.exports = __webpack_public_path__ + "static/recgiraffecomforter-62941a7734eae5b64a4cb59a8be3675c.jpeg";